import { render, staticRenderFns } from "./SubFooter.vue?vue&type=template&id=0c1bc6c9&scoped=true&lang=html"
import script from "./SubFooter.vue?vue&type=script&lang=js"
export * from "./SubFooter.vue?vue&type=script&lang=js"
import style0 from "./SubFooter.vue?vue&type=style&index=0&id=0c1bc6c9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1bc6c9",
  null
  
)

export default component.exports